import { createSlice } from '@reduxjs/toolkit';

const homeSlice = createSlice({
  name: 'home',
  initialState: {
    totalPrice: 0,
  },
  reducers: {
    updatePrice: (state, action) => {
      state.totalPrice = action.payload;
    },
    resetPrice: (state, action) => {
      state.totalPrice = action.payload;
    },
  },
});

const { reducer } = homeSlice;
const selectorhome = (state: any) => state.home;
const { updatePrice, resetPrice } = homeSlice.actions;
export { updatePrice, resetPrice, selectorhome };

export default reducer;